import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorComponent } from '@shared/component/validation-error/validation-error.component';
import { PipeModule } from '@shared/pipe/pipe.module';

@NgModule({
  declarations: [
    ValidationErrorComponent
  ],
  imports: [
    CommonModule,
    PipeModule
  ],
  exports: [
    ValidationErrorComponent
  ]
})
export class ValidationErrorModule { }
